<template>
  <div>
    <div class="title-and-inputarea">
      <!-- 标题 -->
      <span class="title">{{ title }}</span>
      <el-link class="inputarea-button-style"
               v-if="editer_visable_prop"
               @click="editorButtonClick"
               :underline="false"
               type="info"
               icon="el-icon-edit">{{ button_name }}</el-link>

      <el-link class="save-button-style"
               v-if="save_visable_prop"
               @click="cancleButtonClick"
               :underline="false"
               style="float: right; padding-left: 10px"
               type="info">取消</el-link>

      <el-link class="save-button-style"
               v-if="save_visable_prop"
               @click="saveButtonClick"
               :underline="false"
               style="float: right"
               type="info"
               icon="el-icon-folder-checked">保存</el-link>
    </div>
    <!-- 内容展示 -->
    <span>
      <div v-if="show_content_visable_prop"
           class="edito-save-right"
           v-html="show_content"></div>

      <div class="textarea">
        <!-- 长文本框 -->
        <el-input v-if="show_input_prop"
                  :class="{ class_name_one: false, class_name_two: true }"
                  size="mini"
                  v-model="input_text"
                  @input="content_change"
                  placeholder="请输入内容"
                  :style="{ width: input_textarea_width }"
                  type="textarea"
                  maxlength="300"
                  show-word-limit
                  :rows="4"
                  resize="none"></el-input>
      </div>
    </span>
  </div>
</template>

<script>
import Editor from '..//editor/editorV1'
export default {
  name: 'input-area-modify',
  components: {
    'editor-area': Editor,
  },
  data() {
    return {
      info: '',
      is_editor: '',
      editer_visable_prop: this.edit_visable,
      save_visable_prop: this.save_visable,
      show_input_prop: this.show_editor,
      show_content_visable_prop: this.show_content_visable,
      // 输入组件

      input_text: '',
      input_textares: '',
      content: this.show_content,
    }
  },
  props: {
    title: String,
    button_name: String,
    show_content: String, //动态绑定
    editor_text: String,
    input_textares_width: String,
    attribuite: Number,
    // 样式
    input_textarea_width: {
      type: String,
      default: '100%',
    },
    // input_width: String,
    type: String,
    edit_visable: {
      type: Boolean,
      default: true,
    },
    save_visable: {
      type: Boolean,
      default: false,
    },
    show_editor: {
      type: Boolean,
      default: false,
    },
    show_content_visable: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    // 复制文本信息pastContent
    pastContent(event) {
      // console.log(event.target.innerHTML);
      this.$copyText(event.target.innerHTML).then((res) => {
        this.$message({
          message: '信息已复制到剪贴板',
          type: 'success',
        })
      })
    },

    // 编辑时的 方法
    editorButtonClick() {
      this.save_visable_prop = true
      this.editer_visable_prop = false
      this.show_input_prop = true
      this.show_content_visable_prop = false
      this.editor_content = this.show_content
      //   console.log("编辑" + this.editor_content);
      // this.$emit("change")
      this.input_text = this.show_content
    },
    saveButtonClick() {
      this.save_visable_prop = false
      this.editer_visable_prop = true
      this.show_input_prop = false
      this.show_content_visable_prop = true
      //   console.log(this.editor_content);
      let sku_id = this.$emit('save', this.input_text, this.attribuite)
    },
    // 取消编辑
    cancleButtonClick() {
      this.save_visable_prop = false
      this.editer_visable_prop = true
      this.show_input_prop = false
      this.show_content_visable_prop = true
    },
    // 自定义事件
    saveEvent() {},
    // 监听改变值
    content_change(content) {
      this.input_text = content
      // console.log(this.input_text);
    },
  },
}
</script>

<style>
.title-and-inputarea {
  border-left: 5px solid #ff5420;
  padding: 0 5px;
}
.title-and-inputarea:hover .inputarea-button-style {
  display: block;
}

.title {
  font-size: 15px;
  font-weight: bold;
  margin-bottom: 10px;
}
.edito-save-right {
  margin-top: 5px;
  padding: 0px 10px;
  white-space: pre-wrap;
}
.editor {
  margin-top: 10px;
}
.inputarea-button-style {
  display: none;
  float: right;
  font-size: 10px;
}
.save-button-style {
  float: right;
  font-size: 10px;
}
/* v-bind 绑定两种class */
.class_name_one {
  margin-top: 10px;

  width: 100px;
}
.class_name_two {
  width: 300px;
  margin-top: 10px;

  margin-bottom: 10px;
}
</style>